import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';
import APropos from './pages/APropos';
import BTP from './pages/BTP';
import PromotionImmobiliere from './pages/PromotionImmobiliere';
import ProjetImmobilierDetail from './pages/ProjetImmobilierDetail';
import NotFound from './pages/NotFound';
import Mines from './pages/Mines';
import Carriere from './pages/Carriere';
import JobDetail from './pages/JobDetail';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import FloatingButtons from './components/layout/FloatingButtons';
import SmoothRouteTransition from './components/layout/SmoothRouteTransition';
import { FullscreenProvider } from './contexts/FullscreenContext';

// Import des traductions
import './translations';

function App() {
  return (
    <FullscreenProvider>
      <Router>
        <SmoothRouteTransition />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/promotion-immobiliere" element={<PromotionImmobiliere />} />
          <Route path="/promotion-immobiliere/projet/:id" element={<ProjetImmobilierDetail />} />
          <Route path="/btp" element={<BTP />} />
          <Route path="/mines" element={<Mines />} />
          <Route path="/carrieres" element={<Carriere />} />
          <Route path="/carrieres/job/:id" element={<JobDetail />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          {/* Route 404 pour toutes les routes non définies */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <FloatingButtons />
      </Router>
    </FullscreenProvider>
  );
}

export default App;
